import React, { lazy } from 'react';
import { isMobile } from 'react-device-detect';
import { useUserContext } from 'UserContext';
import PublicProviderPageHeader from '../parent-portal/public/public-application/PublicProviderPageHeader';
const AdminNav = lazy(() => import('../internal/shared/Navigation'));
import PublicNavBar from 'parent-portal/LandingPages/Shared/ActionNavBar/PublicNavBar';

const publicProviderPaths = ['/indeed/', '/providers/signup', '/gotandem', '/public/interview/actions'];

const noHeaderRoutes = [
    '/sitter/',
    '/providers/ambassador/',
    '/parent-verification',
    '/job-request',
    '/providers/home',
];

const forcePublicNavRoutes = ['/signin/change/password', '/signin/create/password'];

const Navigation = () => {
    const { user, role } = useUserContext();

    if (forcePublicNavRoutes.some((x) => window.location.pathname.startsWith(x))) {
        return <PublicNavBar />;
    }

    if (!user || user.signup_page < 4) {
        if (publicProviderPaths.some((x) => window.location.pathname.startsWith(x))) {
            return <PublicProviderPageHeader logoWidth={isMobile ? 100 : 175} />;
        }
        return <PublicNavBar />;
    }

    if (noHeaderRoutes.some((x) => window.location.pathname.startsWith(x))) {
        return <></>;
    }

    if (role === 'admin') {
        return <AdminNav />;
    }

    return <></>;
};

export default Navigation;
